module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/offer-icon-957e67ec63d831469bed2926fd3690c9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/offer-icon.svg
// module id = S0bC
// module chunks = 24